import { TabIcon } from "@fluentui/react-icons-mdl2";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { WithTranslator } from "Components/Generic/Translator";
import { isNullOrWhiteSpace } from "Utils/String";
import { TooltipDirection, TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";
import { ICloneRendererProps } from "./ICloneRendererProps";
import { UseCloneRendererStyles } from "./UseCloneRendererStyles";

export const CloneRenderer = WithTranslator((props: ICloneRendererProps): JSX.Element => {
  const {
    fieldName, item, translator, styles
  } = props;
  const styleSet = UseCloneRendererStyles(styles);

  const originId = item[`@originId`];
  if (isNullOrWhiteSpace(originId)) {
    return null;
  }

  return (
    <TooltipHost
      closeDelay={TooltipCloseDelay}
      content={(
        <FilterToolTipContent
          fieldName={fieldName}
          value={translator.get(`clone.iscloned`, `This project is cloned.`)}
          rawValue="@notnull@"
        />
      )}
      delay={TooltipOpenDelay}
      directionalHint={TooltipDirection}
      hostClassName={styleSet.host}
    >
      <div className={styleSet.root}>
        <TabIcon className={styleSet.icon} />
      </div>
    </TooltipHost>
  );
});
